import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import Header from "../components/Header";
import second_bg from "../images/Testimonials.png";
import logo from "../images/logo.png";
import CreatableSelect from "react-select/creatable";
import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";
import { server_API } from "../config";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FiEye, FiEyeOff } from "react-icons/fi";
import axiosInstance from "../axiosInstance";
import { TailSpin } from "react-loader-spinner";

const Company = () => {
  const [email, setEmail] = useState("");
  const location_ref = useLocation();
  const { error, isLoading, Razorpay } = useRazorpay();
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [invalid, setInvalid] = useState(false);
  const [countdown, setCountdown] = useState();
  const [otpVerified, setOtpVerified] = useState(false);
  const [checked, setChecked] = useState(false);
  const [tab, setTab] = useState("trial");
  const [currentStep, setCurrentStep] = useState(0);
  const [companyName, setCompanyName] = useState("");
  const [industry, setIndustry] = useState("");
  const [file, setFile] = useState(null);
  const [website, setWebsite] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyAdd1, setCompanyAdd1] = useState("");
  const [companyAdd2, setCompanyAdd2] = useState("");
  const [companyPincode, setCompanyPincode] = useState("");
  const [companyCity, setCompanyCity] = useState("");
  const [companyCountry, setCompanyCountry] = useState("");
  const [companyState, setCompanyState] = useState("");
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [language, setLanguage] = useState("");
  const [departments, setDepartments] = useState("");
  const [locationValues, setLocationValues] = useState([]);
  const [departmentsValues, setDepartmentsValues] = useState([]);
  const [languageValues, setLanguagesValues] = useState([]);
  const [Employees, setEmployees] = useState("");
  const [extra, setExtra] = useState("");
  // const { planid, planPrice, planName } = location_ref.state;
  const [userId, setUserId] = useState("");
  const [displayedCompanyName, setDisplayedCompanyName] = useState("");
  const [aboutus, setAboutUs] = useState("");
  const [Loading, setIsLoading] = useState(false);
  const [handleDoneLoader, sethandleDoneLoader] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false)
  const [otpGenerated, setOtpGenerated] = useState(false)
  // const handlePayment = (sub_id) => {

  //   const options = {
  //     key: "rzp_live_r5QV0B2p18jMyi",
  //     subscription_id: sub_id,
  //     name: "Novelio Technoliges Pvt Ltd",
  //     // description: "Test Transaction",
  //     // order_id: "order_PVWc7GfAqQbvuI", // Generate order_id on server
  //     // customer_id:"cust_PVWc7LEnjMBXQl",
  //     recurring: "1",
  //     prefill: {
  //       email: email,
  //     },
  //     handler: (response) => {
  //       axios
  //         .post(`${server_API}/v1/payment/create`, {
  //           paymentid: response.razorpay_payment_id,
  //           emailid: email,
  //         })
  //         .then((res) => {
  //           console.log(res);
  //           setTab("company");
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //       // alert(response.razorpay_payment_id);
  //       // alert(response.razorpay_order_id);
  //       // alert(response.razorpay_signature);
  //     },

  //     theme: {
  //       color: "#F37254",
  //     },
  //   };

  //   const razorpayInstance = new Razorpay(options);
  //   razorpayInstance.open();
  // };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    if (
      droppedFile &&
      (droppedFile.type === "image/jpeg" || droppedFile.type === "image/png")
    ) {
      setFile(droppedFile);
    } else {
      alert("Please drop a JPEG or PNG image.");
    }
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];

    if (
      selectedFile &&
      (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png")
    ) {
      setFile(selectedFile);
    } else {
      alert("Please select a JPEG or PNG image.");
    }
  };
  const handleDeleteFile = () => {
    setFile(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // To allow drop
  };
  const steps = ["Step 1", "Step 2", "Step 3"];
  const stepPositions = [2, 35, 68];

  const handleStepClick = (index) => {
    // if(index ==1){

    // }

    // // if(index == 3){
    // //   axios.patch(`${server_API}/v1/company/update`,{
    // //     uuid:cid,
    // //     website:website,
    // //     email:companyEmail,
    // //     phone:companyPhone,
    // //     address:companyAdd1 + ' ' + companyAdd2 + ' ' + companyCity + ' ' + companyState + ' ' + companyCountry +' '+ companyPincode,
    // //     location:locationValues.toString(),
    // //     departments:departmentsValues
    // //   })
    // //   .then((response) =>{
    // //     console.log(response);
    // //   })
    // //   .catch((error) =>{
    // //     console.log(error);
    // //   })
    // // }
    setCurrentStep(index);
  };

  const [showPassword, setShowPassword] = useState(false);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const publicDomains = [
      "gmail.com",
      "yahoo.com",
      "outlook.com",
      "hotmail.com",
      "icloud.com",
      "aol.com",
      "protonmail.com",
      "zoho.com",
      "mail.com",
      "gmx.com"
    ];

    if (!re.test(email)) return false;

    const domain = email.split("@")[1].toLowerCase();
    return !publicDomains.includes(domain);
  };

  const [cid, setCid] = useState("");
  const [isCreatingCompany, setIsCreatingCompany] = useState(false);

  const handleCompanyCreation = async () => {
    setIsCreatingCompany(true);


    const trimmedCompanyName = companyName.trim();
    const trimmedWebsite = website.trim();


    let newwebsite = trimmedWebsite;
    if (!trimmedWebsite.startsWith("http://") && !trimmedWebsite.startsWith("https://")) {
      newwebsite = "https://" + trimmedWebsite;
    }

    try {
      const companyRes = await axios.post(`${server_API}/v1/company/create`, {
        name: trimmedCompanyName,
        website: newwebsite,
        location: locationValues.toString(),
        departments: departmentsValues,
        planname: "free-trial",
      });

      const companyId = companyRes.data.message;
      localStorage.setItem("companyId", companyId);
      setCid(companyId);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("companyid", companyId);

      await axios.post(`${server_API}/v1/company/logo`, formData);

      const userRes = await axios.post(`${server_API}/v1/user/create`, {
        comapnyid: companyId,
        privilege: "Admin",
        email: email.trim(),
        name: "Admin",
        status: "sent",
        password: "password",
      })

      setUserId(userRes.data.message);

      await axios.post(`${server_API}/v1/company/sendsalesemail`, {
        companyName: trimmedCompanyName,
        userName: "Admin",
        userEmail: email.trim(),
      })



      await axios.post(`${server_API}/v2/user/login`, {
        email: email.trim(),
        password: "password",
        otp: "",
      });

    } catch (error) {
      console.error(error);
      toast.error("Error creating company or user.");
    } finally {
      handleStepClick(1);
      setIsCreatingCompany(false);
    }
  };



  const handleGenerateOtp = () => {

    if (!email.trim()) {
      setEmail("")
      toast.error("Email cannot be empty.");
      return;
    }

    if (!validateEmail(email)) {
      setEmail("")
      toast.error("Please use a valid company email address.");
      return;
    }

    if (email.length > 0) {
      setOtpLoader(true)
      axios.post(`${server_API}/v1/email/genOtpv2/${email}`)
        .then((res) => {
          setCountdown(30);
          setOtpGenerated(true)
          setOtpLoader(false)
        })
        .catch((err) => {
          if (err.status == 409) {
            toast.error("This Email is already registered", { position: "top-center", className: "dark-mode-toast" })
            setEmail("")

          }
          else {
            alert("Invitation mail can't be sent Please try again.");
          }
          setOtpLoader(false)
        }
        )
    } else {
      toast.error("Please enter the email before sending the OTP", { position: "top-center", className: "dark-mode-toast" })
    }

  }

  // 👇 Final password update on clicking "Next"
  const handleFinalNextClick = async () => {
    if (!userName.trim()) {
      toast.error("Please enter your name first.");
      return;
    }

    if (!email.trim()) {
      toast.error("Email cannot be empty.");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email.");
      return;
    }

    if (!userPassword.trim()) {
      toast.error("Please enter a password.");
      return;
    }

    setIsLoading(true);

    try {
      if (!userId) {
        await handleCompanyCreation();
      }


      await axiosInstance.patch(`/v1/user/update`, {
        uuid: userId,
        status: "accepted",
        password: userPassword,
        name: userName
      });

      toast.success("Password updated successfully!");
      handleStepClick(2);
    } catch (error) {
      console.error("Error during next step:", error);

      if (error.response?.status === 401) {
        toast.error("Login failed. Please check default credentials.");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleComplete = () => {

    sethandleDoneLoader(true);
    axiosInstance
      .patch(`${server_API}/v1/company/update`, {
        uuid: cid,
        name: displayedCompanyName?.length > 0 ? displayedCompanyName : companyName,
        about: aboutus,
      })
      .then((response) => {
        console.log(response);
        sethandleDoneLoader(false);
        window.location.href = `${server_API}/app/#/jobs/new`;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong. Please try again.");
        setIsLoading(false);
      });
  };

  // const handleEmployees = (index) => {
  //   setEmployees(index);
  // };

  const handleInputChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // Only allow digits

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    setInvalid(false); // reset invalid state on change

    if (value && index < 5) {
      const nextInput = document.getElementById(`code-input-${index + 1}`);
      nextInput?.focus();
    }

    // Auto verify when all digits entered
    if (newCode.every((digit) => digit.length === 1)) {
      verifyOTP(newCode.join(""));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !code[index]) {
      const prevInput = document.getElementById(`code-input-${index - 1}`);
      prevInput?.focus();
    }
  };

  const verifyOTP = (finalOtp) => {
    axios
      .get(`${server_API}/v1/email/verify/${email}/${finalOtp}`)
      .then((res) => {
        setOtpVerified(true);
      })
      .catch(() => {
        setInvalid(true);
        setCode(["", "", "", "", "", ""]);
      });
  };



  useEffect(() => {
    const isValid =
      companyName.trim() !== "" &&
      file !== null &&
      departments && departments.length > 0 &&
      website.trim() !== "" &&
      location && location.length > 0;

    setIsFormValid(isValid);
  }, [companyName, file, departments, website, location]);


  // const handleTrial = () => {
  //   axios
  //     .post(`${server_API}/v1/payment/subscription`, {
  //       emailid: email,
  //       planid: planid,
  //       name: name,
  //     })
  //     .then((response) => {
  //       console.log(response);
  //       handlePayment(response.data.message);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       alert("Email id is already in use");
  //     });
  // };

  // const handleDone = () => {
  //   localStorage.setItem("tab", "trial");
  //   setTab("trial");
  // };

  const majorCities = [
    { label: "Delhi", value: "Delhi" },
    { label: "Mumbai", value: "Mumbai" },
    { label: "Kolkata", value: "Kolkata" },
    { label: "Chennai", value: "Chennai" },
    { label: "Jaipur", value: "Jaipur" },
    { label: "Pune", value: "Pune" },
    { label: "Ahmedabad", value: "Ahmedabad" },
    { label: "Bangalore", value: "Bangalore" },
    { label: "Hyderabad", value: "Hyderabad" },
    { label: "Surat", value: "Surat" },
    { label: "Agra", value: "Agra" },
    { label: "Kanpur", value: "Kanpur" },
    { label: "Lucknow", value: "Lucknow" },
    { label: "Nagpur", value: "Nagpur" },
    { label: "Indore", value: "Indore" },
    { label: "Bhopal", value: "Bhopal" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Patna", value: "Patna" },
    { label: "Dehradun", value: "Dehradun" },
    { label: "Coimbatore", value: "Coimbatore" },
    { label: "Madurai", value: "Madurai" },
    { label: "Vijayawada", value: "Vijayawada" },
    { label: "Mangalore", value: "Mangalore" },
    { label: "Mysore", value: "Mysore" },
    { label: "Trivandrum", value: "Trivandrum" },
    { label: "Tirupati", value: "Tirupati" },
    { label: "Nellore", value: "Nellore" },
    { label: "Guntur", value: "Guntur" },
    { label: "Warangal", value: "Warangal" },
    { label: "Kurnool", value: "Kurnool" },
    { label: "Rajahmundry", value: "Rajahmundry" },
    { label: "Bhubaneswar", value: "Bhubaneswar" },
    { label: "Guwahati", value: "Guwahati" },
    { label: "Ranchi", value: "Ranchi" },
    { label: "Jamshedpur", value: "Jamshedpur" },
    { label: "Cuttack", value: "Cuttack" },
    { label: "Durgapur", value: "Durgapur" },
    { label: "Asansol", value: "Asansol" },
    { label: "Siliguri", value: "Siliguri" },
    { label: "Dhanbad", value: "Dhanbad" },
    { label: "Rourkela", value: "Rourkela" },
    { label: "Haldia", value: "Haldia" },
    { label: "Agartala", value: "Agartala" },
    { label: "Shillong", value: "Shillong" },
    { label: "Imphal", value: "Imphal" },
    { label: "Kohima", value: "Kohima" },
    { label: "Aizawl", value: "Aizawl" },
    { label: "Gangtok", value: "Gangtok" },
    { label: "Itanagar", value: "Itanagar" },
    { label: "Dimapur", value: "Dimapur" },
    { label: "Silchar", value: "Silchar" },
    { label: "Dibrugarh", value: "Dibrugarh" },
    { label: "Tripura", value: "Tripura" },
    { label: "Jorhat", value: "Jorhat" },
    { label: "Gurugram", value: "Gurugram" },
  ];

  const departmentsOptions = [
    { label: "Sales", value: "Sales" },
    { label: "Marketing", value: "Marketing" },
    { label: "Finance", value: "Finance" },
    { label: "Information Technology", value: "Information Technology" },
    { label: "IT Infrastructure", value: "IT Infrastructure" },
    { label: "Human Resources", value: "Human Resources" },
    { label: "Data Science", value: "Data Science" },
    { label: "Collections", value: "Collections" },
    { label: "Community Management", value: "Community Management" },
  ];
  const languageOptions = [
    { label: "option1", value: "option1" },
    { label: "option2", value: "option2" },
    { label: "option3", value: "option3" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.length > 0) {
      const lv = location.map((l) => {
        return l.value;
      });
      setLocationValues(lv);
    }

    if (departments.length > 0) {
      const lv = departments.map((l) => {
        return l.value;
      });
      setDepartmentsValues(lv);
    }
    if (language.length > 0) {
      const lv = language.map((l) => {
        return l.value;
      });
      setLanguagesValues(lv);
    }
  }, [location, language, departments]);

  return (
    <div className="h-full ">
      <div className=" bg-[#0d121e] h-full bg-cover font-thicboi px-6 md:px-20 py-10">
        <Header />
        {/* <div className="flex flex-col  items-center  text-center gap-16 px-6 md:p-20">
               
                <div className="w-full flex items-center justify-center ">
                    <p className="text-white text-center font-bold font-thicboi text-3xl md:text-5xl">Self Sign up</p>
                </div> 

            </div> */}
      </div>

      <div
        style={{ backgroundImage: `url(${second_bg})` }}
        className="bg-local bg-bottom bg-cover md:flex gap-10 h-full"
      >
        {/* Left Content */}
        <div className="md:w-1/2 py-40 px-5 md:px-28 md:py-[96px] flex flex-col gap-14">
          <div>
            <img src={logo} className="h-14" alt="logo" />
          </div>

          {tab == "trial" && (
            <div className="flex flex-col gap-6">
              <p className="font-thicboi font-semibold text-3xl text-left text-white">
                Sign Up and post your 1st job free
              </p>
              <p className="font-thicboi font-medium text-base text-left text-white">
                Discover how our AI-powered platform can transform your
                recruitment process.
              </p>
              <ul className="list-disc px-4">
                <li className="font-thicboi font-normal text-base text-left text-[#84818A]">
                  Streamline hiring
                </li>
                <li className="font-thicboi font-normal text-base text-left text-[#84818A]">
                  Find top talent with precision
                </li>
                <li className="font-thicboi font-normal text-base text-left text-[#84818A]">
                  Save time and resources
                </li>
              </ul>
              <p className="font-thicboi font-normal text-base text-left text-[#84818A]">
                Sign up now and take the first step toward smarter hiring!
              </p>
            </div>
          )}

          {tab == "company" && (
            <div className="flex flex-col  gap-6">
              <p className="font-thicboi font-semibold text-3xl text-left text-white">
                You are a few steps from your first job posting on Northstarz, and we're thrilled to have you on board.
              </p>

              <p className="font-thicboi font-normal text-base text-left text-[#84818A]">
                Thank you for joining Northstarz! We're excited to help you
                transform your recruitment process.
              </p>
              <p className="font-thicboi font-normal text-base text-left text-[#84818A]">
                To get started, please provide a few final details. Once
                completed, you'll unlock the full potential of our platform to
                streamline and enhance your hiring journey.
              </p>
            </div>
          )}
        </div>

        {/* White Background Section */}
        <div className="bg-white md:w-1/2 h-full rounded-xl md:rounded-r-none ">
          <div className="py-40 px-5 md:px-28 md:py-[96px] flex flex-col gap-14">
            {tab == "trial" && (
              <div className=" flex flex-col gap-10">
                <div className="font-medium text-3xl">
                  Sign up free to try now!
                </div>
                <div className="flex flex-col gap-8">

                  <div className="flex flex-col gap-2  pb-2">
                    <div className="flex items-center justify-between">
                      <div>

                        <span className="font-thicboi text-base text-[#84818A]">Email address</span>
                      </div>
                      <button
                        disabled={!email}
                        onClick={handleGenerateOtp}
                        className="text-[#2E90FA] text-sm underline disabled:text-gray-400 disabled:cursor-not-allowed"
                      >
                        {otpLoader ? (
                          <div className="flex w-full justify-center">
                            <TailSpin
                              className="text-center mx-auto"
                              color="black"
                              height="30"
                              width="30"
                            ></TailSpin>
                          </div>
                        ) : (
                          "Send OTP"
                        )}
                      </button>
                    </div>
                    <input
                      className="font-thicboi font-normal bg-transparent w-full text-base border-b-[1px] border-gray-500 text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                    />
                    {otpGenerated && <p className="font-thicboi text-xs text-[#84818A]">Please use the OTP sent on your email address</p>}
                  </div>
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                      <span className="font-thicboi text-base text-[#84818A]">Verification Code</span>
                      {countdown > 0 ? (
                        <span className="text-sm text-[#2E90FA]">{countdown}s</span>
                      ) : (
                        <button
                          onClick={handleGenerateOtp}
                          className="text-[#2E90FA] text-sm underline"
                        >
                          Resend OTP
                        </button>
                      )}
                    </div>

                    <div className="flex gap-2">
                      {code.map((digit, index) => (
                        <input
                          key={index}
                          id={`code-input-${index}`}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleInputChange(e.target.value, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className={`w-10 h-12 text-center text-xl border rounded-md transition-colors duration-200
        ${otpVerified
                              ? "bg-green-100 border-green-500"
                              : invalid
                                ? "bg-red-100 border-red-500"
                                : "bg-gray-100 border-gray-300"
                            }
        focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <input
                      type="checkbox"
                      className="w-10 h-10 text-blue-500 border-gray-300 rounded "
                      value={checked}
                      onChange={() => {
                        setChecked(!checked);
                      }}
                    />
                    <p className="text-[#84818A] font-thicboi text-sm font-normal">
                      By clicking Create account, I agree that I have read and
                      accepted the <Link
                        to={"https://northstarz.ai/#/terms"}
                        className="text-[#2E90FA] underline"
                      >
                        Terms of Use
                      </Link> and <Link
                        to={"https://northstarz.ai/#/privacy"}
                        className="text-[#2E90FA] underline"
                      >
                        Privacy Policy.
                      </Link>
                    </p>
                  </div>

                  <div className="flex flex-col gap-2">
                    <button
                      className={
                        checked && email.length > 0 && otpVerified
                          ? "bg-[#2E90FA] text-white font-thicboi text-sm font-normal rounded-xl p-3"
                          : "bg-gray-400 text-white font-thicboi text-sm font-normal rounded-xl p-3"
                      }
                      disabled={!(checked && email.length > 0 && otpVerified)}
                      onClick={() => {
                        setTab("company");
                      }}
                    >
                      Start a free trial
                    </button>
                  </div>

                  <hr></hr>
                  <p className="font-thicboi font-normal text-base  text-[#84818A] mb-4">
                    Already have an account?{" "}
                    <Link
                      to={"https://northstarz.ai/login"}
                      className="text-[#2E90FA] underline"
                    >
                      Sign in
                    </Link>
                  </p>
                </div>
              </div>
            )}
            {tab == "company" && (
              <div className=" flex flex-col gap-10">
                <div className="flex flex-col items-center">
                  <div className="relative w-full max-w-xl">
                    <div className="flex items-center w-full absolute top-1/2 transform -translate-y-1/2 ">
                      {steps.map((step, index) => (
                        <div
                          key={index}
                          className="flex items-center w-full relative"
                        >
                          <div
                            className={`flex items-center justify-center w-10 h-10 rounded-full  transition-all duration-300 cursor-pointer ${"  border-4 border-[#305591] text-white"}`}
                          ></div>

                          {index !== steps.length - 1 && (
                            <div
                              className={`flex-grow h-1 bg-gray-300 transition-all duration-300`}
                            ></div>
                          )}
                        </div>
                      ))}
                    </div>

                    <div
                      className={`absolute top-1/2 transform -translate-y-1/2 transition-all duration-500 ease-in-out bg-[#305591] rounded-full w-6 h-6`}
                      style={{
                        left: `${stepPositions[currentStep]}%`,
                      }}
                    ></div>
                  </div>
                </div>
                {currentStep == 0 && (
                  <>
                    <div className="flex flex-col gap-2">
                      <span className="font-medium text-3xl">
                        Tell us about your company{" "}
                      </span>

                    </div>
                    <div className="flex flex-col gap-14">
                      <div className="px-2 flex flex-col gap-8">
                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 ">
                          <span className="font-thicboi text-base text-[#84818A] ">
                            Company Name
                            <span className="font-thicboi text-base text-red-600 ">
                              *
                            </span>
                          </span>

                          <input
                            className="font-thicboi font-normal bg-transparent  w-full text-base  text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none focus:border-none"
                            value={companyName}
                            onChange={(e) => {
                              setCompanyName(e.target.value);
                            }}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <span className="font-thicboi text-base text-[#84818A] ">
                            Logo
                            <span className="font-thicboi text-base text-red-600 ">
                              *
                            </span>
                          </span>
                          <div
                            className="flex flex-col gap-1 items-center justify-center border-[1px] border-[#DDDFE1] rounded-md p-6"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                          >
                            {file && (
                              <div className="flex items-start gap-4">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt="Uploaded file preview"
                                  className="w-32 h-32 object-cover mt-2"
                                />
                                <button
                                  className=" text-red-500"
                                  onClick={handleDeleteFile}
                                >
                                  &#10005; {/* This is the cross (X) icon */}
                                </button>
                              </div>
                            )}
                            {!file && (
                              <>
                                <p className="text-[#ABAFB3] font-thicboi text-base font-normal">
                                  Drag an image Here
                                </p>
                                <p className="text-[#ABAFB3] font-thicboi text-base font-normal">
                                  Or
                                </p>
                                <button
                                  className="bg-[#3C60A5] text-white font-thicboi text-xs font-normal px-6 py-2 rounded-sm"
                                  onClick={() =>
                                    document
                                      .getElementById("file-input")
                                      .click()
                                  }
                                >
                                  Choose a file
                                </button>
                                <input
                                  id="file-input"
                                  type="file"
                                  accept="image/jpeg, image/png"
                                  onChange={handleFileSelect}
                                  className="hidden"
                                />
                              </>
                            )}
                          </div>
                          <span className="font-thicboi text-xs text-[#84818A]">
                            Logo Size: 500*500, Formats: png, jpg
                          </span>
                        </div>

                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 ">
                          <span className="font-thicboi text-base text-[#84818A] ">
                            Website
                            <span className="font-thicboi text-base text-red-600 ">
                              *
                            </span>
                          </span>

                          <input
                            className="font-thicboi font-normal bg-transparent  w-full text-base  text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none focus:border-none"
                            value={website}
                            onChange={(e) => {
                              setWebsite(e.target.value);
                            }}
                          />
                        </div>

                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 ">
                          <span className="font-thicboi text-base text-[#84818A] ">
                            Departments
                            <span className="font-thicboi text-base text-red-600 ">
                              *
                            </span>
                          </span>
                          <CreatableSelect
                            value={departments}
                            onChange={(selectedOption) => {
                              setDepartments(selectedOption);
                            }}
                            options={departmentsOptions}
                            isClearable
                            isMulti
                            isSearchable
                            placeholder="Add Departments where you hire"
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                border: "none",
                                boxShadow: "none",
                              }),
                            }}
                          />
                        </div>



                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 ">
                          <span className="font-thicboi text-base text-[#84818A] ">
                            Location
                            <span className="font-thicboi text-base text-red-600 ">
                              *
                            </span>
                          </span>
                          <CreatableSelect
                            value={location}
                            onChange={(selectedOption) => {
                              setLocation(selectedOption);
                            }}
                            options={majorCities}
                            isClearable
                            isMulti
                            isSearchable
                            placeholder="Add Cities where you hire"
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                border: "none",
                                boxShadow: "none",
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="flex flex-col gap-2 w-[30%]">
                        <button
                          className={`bg-[#2E90FA] text-white font-thicboi text-sm font-normal rounded-lg p-3 ${(!isFormValid || isCreatingCompany) ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                          disabled={!isFormValid || isCreatingCompany}
                          onClick={() => {
                            handleCompanyCreation()
                          }}
                        >
                          {isCreatingCompany ? (
                            <div className="flex w-full justify-center">
                              <TailSpin
                                className="text-center mx-auto"
                                color="white"
                                height="30"
                                width="30"
                              ></TailSpin>
                            </div>
                          ) : (
                            "Next"
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {currentStep == 1 && (
                  <>
                    <div className="flex flex-col gap-2">
                      <span className="font-medium text-3xl">About You</span>
                      <p className="font-thicboi font-normal text-base text-[#92929D]">
                        To set up your account, we just need your details
                      </p>
                    </div>

                    <div className="flex flex-col gap-14">
                      <div className="px-2 flex flex-col gap-8">
                        <div className="flex gap-4">
                          {/* Name Field */}
                          <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 w-full">
                            <span className="font-thicboi text-base text-[#84818A]">
                              Name
                            </span>
                            <input
                              className="font-thicboi font-normal bg-transparent w-full text-base text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none"
                              placeholder="Enter your name"
                              value={userName}
                              onChange={(e) => setUserName(e.target.value)}
                            />
                          </div>

                          {/* Email Field */}
                        </div>

                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 w-full">
                          <span className="font-thicboi text-base text-[#84818A]">
                            Email
                          </span>
                          <p

                            className="font-thicboi font-normal bg-transparent w-full text-base text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none"

                          >{email}</p>
                        </div>

                        {/* Password Field */}
                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 relative">
                          <span className="font-thicboi text-base text-[#84818A]">
                            Create password{" "}
                            <span className="text-red-600">*</span>
                          </span>
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Create Your Password"
                            className="font-thicboi font-normal bg-transparent w-full text-base text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none"
                            value={userPassword}
                            onChange={(e) => setUserPassword(e.target.value)}
                          />
                          {/* Eye Toggle Icon */}
                          <div
                            className="absolute right-3 top-10 cursor-pointer"
                            onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? (
                              <FiEyeOff className="text-gray-600" />
                            ) : (
                              <FiEye className="text-gray-600" />
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="flex gap-2">
                        <button
                          className="bg-[#2E90FA] text-white font-thicboi text-sm font-normal rounded-lg p-3 w-[30%] disabled:opacity-50"
                          disabled={!userId || isCreatingCompany || userPassword.trim() === ""}
                          onClick={handleFinalNextClick}
                        >
                          {Loading ? (
                            <div className="flex w-full justify-center">
                              <TailSpin
                                className="text-center mx-auto"
                                color="white"
                                height="30"
                                width="30"
                              />
                            </div>
                          ) : (
                            "Next"
                          )}
                        </button>


                      </div>
                    </div>
                  </>
                )}
                {currentStep == 2 && (
                  <>
                    <div className="flex flex-col gap-2">
                      <span className="font-medium text-3xl">You are all set! </span>
                      <p className="font-thicboi font-normal text-base text-[#92929D]">
                        Update the information about your company that will be seen to job seekers
                      </p>
                    </div>
                    <div className="flex flex-col gap-4">
                      <div className="px-2 flex flex-col gap-8">
                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 ">
                          <span className="font-thicboi text-base text-[#84818A] ">
                            Name of Company to be displayed to candidate
                          </span>
                          <input
                            className="font-thicboi font-normal bg-transparent  w-full text-base  text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none focus:border-none"
                            value={displayedCompanyName}
                            onChange={(e) => {
                              setDisplayedCompanyName(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="px-2 flex flex-col gap-8">
                        <div className="flex flex-col gap-2 border-b-[1px] border-gray-500 ">
                          <span className="font-thicboi text-base text-[#84818A] ">
                            Tell us something about your company
                          </span>
                          <textarea
                            className="font-thicboi font-normal bg-transparent  w-full text-base  text-black placeholder-gray-400 placeholder-opacity-75 placeholder:text-sm focus:outline-none focus:border-none"
                            value={aboutus}
                            onChange={(e) => {
                              setAboutUs(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="flex gap-2 ">
                        <button
                          className="bg-[#2E90FA] text-white font-thicboi text-sm font-normal rounded-lg p-3 w-[30%]"
                          disabled={handleDoneLoader}
                          onClick={() => {
                            handleComplete();
                          }}
                        >
                          {handleDoneLoader ? (
                            <div className="flex w-full justify-center">
                              <TailSpin
                                className="text-center mx-auto"
                                color="white"
                                height="30"
                                width="30"
                              ></TailSpin>
                            </div>
                          ) : (
                            "Done"
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
      <ToastContainer />
    </div>
  );
};

export default Company;
